import reducer from './reducers'

import * as validationsAutomationsOperations from './operations'
import * as validationsAutomationsEndpoints from './paths'

export { validationsAutomationsOperations, validationsAutomationsEndpoints }

export default reducer
